// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"06a6ce90","513":"42540181"}[chunkId] + ".1790794919743.chunk.css";
};